module.exports = __webpack_public_path__ + "20230117/img/slide1_video.50937fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide1_video.png
// module id = ogTQ
// module chunks = 1